import React from 'react';
import { Mail, Smartphone, KeyRound } from 'lucide-react';

const CHANNEL_ICONS = { sms: Smartphone, email: Mail, totp: KeyRound };

/**
 * 2FA kodunun hangi kanaldan geleceğini seçtirir.
 *
 * Kullanılamayan kanal listeden düşürülmez, gerekçesiyle birlikte sönük
 * gösterilir: üyenin "SMS neden yok" sorusunun cevabı ekranda olmalıdır.
 * Üye hesap sayfası ile yönetim paneli farklı paletler kullandığından renk
 * dışarıdan `accent` ile verilir.
 */
const TwoFactorChannelPicker = ({
  channels = [],
  value,
  onChange,
  disabled = false,
  accent = 'var(--accent-primary, var(--pusu-gold))',
  muted = 'var(--admin-text-secondary, var(--pusu-muted))',
}) => {
  if (!channels.length) return null;
  return (
    <div className="mt-4">
      <div className="text-xs mb-2" style={{ color: muted }}>
        Doğrulama yöntemini seçin
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {channels.map((item) => {
          const Icon = CHANNEL_ICONS[item.channel] || Mail;
          const selected = value === item.channel;
          const usable = item.available && !disabled;
          return (
            <button
              key={item.channel}
              type="button"
              disabled={!usable}
              aria-pressed={selected}
              onClick={() => onChange(item.channel)}
              className="text-left rounded-xl px-3 py-2.5 transition-colors disabled:cursor-not-allowed"
              style={{
                background: selected && usable
                  ? `color-mix(in srgb, ${accent} 14%, transparent)`
                  : `color-mix(in srgb, ${muted} 8%, transparent)`,
                border: `1px solid ${selected && usable
                  ? accent
                  : `color-mix(in srgb, ${muted} 22%, transparent)`}`,
                opacity: item.available ? 1 : 0.55,
              }}
            >
              <span className="flex items-center gap-2 text-sm font-semibold">
                <Icon size={14} style={{ color: usable ? accent : muted }} />
                {item.label || item.channel}
              </span>
              <span className="block text-xs mt-1" style={{ color: muted }}>
                {item.available
                  ? item.channel === 'totp'
                    ? 'QR veya kurulum anahtarıyla ekleyin; kodu uygulamadan alın.'
                    : (item.target || 'Kayıtlı adresinize gönderilir')
                  : item.reason}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TwoFactorChannelPicker;
